
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/kevel",
      function () {
        return require("private-next-pages/destinations/kevel.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/kevel"])
      });
    }
  